import React, {lazy, Suspense} from 'react';
import {Route, Routes} from "react-router-dom";
import {Skeleton} from "antd";


const CasualAndLeaveRouter = lazy(() => import('./casual-and-compensatory/Router'));
const TimeSheetRouter = lazy(() => import('./time-sheet/Router'));
const WageRouter = lazy(() => import('../wage/Router'));
const ReportRouter = lazy(() => import('../report/Router'));
const Error404 = lazy(() => import("../../../common/error/Error404"));


const TimeKeepingRouter = props => {
    return (
        <Suspense fallback={<Skeleton />}>
        <Routes path="/">
            <Route path="casual-and-compensatory/*" element={<CasualAndLeaveRouter/>}/>
            <Route path="time-sheet/*" element={<TimeSheetRouter/>}/>
            <Route path="wage/*" element={<WageRouter/>}/>
            <Route path="report/*" element={<ReportRouter/>}/>
            <Route path="*" element={<Error404/>}/>
        </Routes>
       </Suspense>
    );
};

TimeKeepingRouter.propTypes = {};

export default TimeKeepingRouter;
